<template>
    <v-card>
        <v-card-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="openAdd" v-if="userIsFleetManager">Add</v-btn>
            <v-dialog persistent v-model="dialog" max-width="500px">
                <Form
                    v-model="model"
                    @add="submitAdd($event.id, $event.model)"
                    @edit="submitEdit($event.id, $event.model)"
                >
                    <template v-slot:header>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialog=false" icon text>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:actions>
                        <v-btn @click="dialog=false">Cancel</v-btn>
                    </template>
                </Form>
            </v-dialog>
        </v-card-title>

        <v-data-table
            :items="containerSizes"
            :items-per-page="options.itemsPerPage"
            :headers="headers"
            :loading="$wait.is(['loading container sizes'])"
            :footer-props.sync="footerProps"
            :options.sync="options"
        >
            <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
            <template v-slot:item="props">
                <tr @click="userIsFleetManager ? openEdit(props.item) : null">
                    <td>{{props.item.description}}</td>
                    <td>{{props.item.sortOrder}}</td>
                    <td width="76px" class="pl-0" v-if="userIsFleetManager">
                        <v-btn @click="openEdit(props.item)" icon>
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:no-results>
                <v-layout row align-center>
                    <v-flex>No matching records found</v-flex>
                </v-layout>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
  import Container from '@/components/Containers/ContainersClient.vue';
  import { Event } from '@/plugins/bus';
  import Form from './Form.vue';

  export default {
    components: {
      Form
    },
    mixins: [Container],
    data() {
      return {
        containerSizes: [],
        dialog: false,
        search: '',
        options: {
          itemsPerPage: 10,
          sortBy: ['sortOrder']
        },
        footerProps: {
          itemsPerPageOptions: [10, 50, 100]
        },
        headers: [
          {text: 'Size', value: 'description'},
          {text: 'Sort Order', value: 'sortOrder'}
        ],
        model: {}
      };
    },
    methods: {
      openAdd() {
        this.model = {};
        this.dialog = true;
      },
      openEdit(size) {
        this.model = {...size}; // spread operator intentionally used to create clone
        this.dialog = true;
      },
      async submitAdd(id, model) {
        this.dialog = false;
        await this.addContainerSize(id, model);
      },
      async submitEdit(id, model) {
        this.dialog = false;
        await this.updateContainerSize(id, model);
      },
      async handleContainerSizesUpdated() {
        this.containerSizes = await this.getContainerSizes();
      }
    },
    async mounted() {
      this.containerSizes = await this.getContainerSizes();
      this.$bus.$on(Event.ContainerSizesUpdated, this.handleContainerSizesUpdated);
    },
    async destroyed() {
      this.$bus.$off(Event.ContainerSizesUpdated, this.handleContainerSizesUpdated);
    }
  };
</script>
